import { AnyTokenSymbol } from './tokens-list';

type Token = {
  name: string;
  symbol: AnyTokenSymbol;
  decimals: number;
};

export const formatBalance = (
  value: number,
  token: Token,
  decimals?: number
) => {
  const newValue = value / 10 ** token.decimals;

  return newValue.toFixed(decimals || 2);
};

export const formatAddress = (account: string, isLong?: boolean) => {
  if (!account) return '';
  const first = account.substring(0, isLong ? 8 : 6);
  const last = account.substring(account.length - (isLong ? 8 : 4));
  return `${first}...${last}`;
};

export const formateAddressInTableCell = (account: string) => {
  if (!account) return '';
  const first = account.substring(0, 21);
  return `${first}...`;
};
